
<div class="tpm-box-dash-hdr-bar">
  <h2 class="tpm-box-dash-hdr">{{selectedBusinessUnit.displayName}}</h2>
</div>

<!--Div : Row : Row below BU Header with 2 columns for 1. manage and contact section and 2. Reports section-->
<div class="row talent-payroll ManageTimecardBlock d-inline-block">

  <!--Div : Col : Manage timecard and contact section-->
  <div class="row manage-timecard-section ps-0 pe-0">
    <div class="row manage-timecard-header ps-0 pe-0">
      <!--Div : Col : Managetimecard section-->
      <div class="row manage-timecard-column p-0">
        <div class="tpm-timesheet-action-container ps-0">
          <div class="action-element" authenticate-user="ManageTimecards.Retrieve">
            <a class="btn btn-primary btn-block  action-wrapper talent-payroll-btncls" style="border:none;" (click)="openRunningTimecard()">Manage Timecards</a>
          </div>
        </div>
      </div>
      <!--Div : Col : Contact section-->
      <div class="row manage-timecard-contact-column p-0">
        <div class="p-0">
          <input type="text"
                 [(ngModel)]="queryContainer.query.searchTerm.description"
                 placeholder="CONTACT"
                 class="timesheetTextbox dashboard-contact"/>
          <input type="button" class="btn btn-primary action-wrapper timesheetSearchButton"
                 (click)="search()"
                 [disabled]="searchButtonDisable" value="Search"/>
          <input type="button" class="btn btn-secondary action-wrapper timesheetSearchButton"
                 (click)="reset()" value="Reset"/>
        </div>
      </div>
    </div>
    <!--Div : Row : 2nd row for Timecard details-->
    <div class="row header-section p-0">
      <div class="header-section1 p-0 m-0 d-flex" style="height:100%;">
        <div style="width:49% ;  display:table-cell ; text-align:center; background-color:white">
          <div style="height: 40px; text-align: center; background-color: #F5F5F5;line-height: 40px;">Pending Timecards</div>
            <div class="float-start" style="text-align: center; background-color: white; width: 65%">
              <div class="float-start mt-5">
                <pending-timecards-chart *ngIf="dashboardData" [chartData]="dashboardData"></pending-timecards-chart>
              </div>
              <div class="float-end mt-5">
                <pending-timecards-dept *ngIf="dashboardData" [chartData]="dashboardData"></pending-timecards-dept>
              </div>
            </div>
          </div>
        <div style="width:1%"></div>
        <div style="width:50% ;  display:table-cell ; text-align:center; background-color:white">
          <div style="height:40px;text-align:center;background-color:#F5F5F5;line-height: 40px;">Approved Timecards</div>
          <div style="width: 100%; text-align: center; background-color: white; height: 235px;">
            <approved-timecards-charts *ngIf="dashboardData" [chartData]="dashboardData"></approved-timecards-charts>
          </div>
        </div>
         </div>
      </div>
    </div>

  <!--Div : Col : Space between Managetimecard and reports-->
  <div style="width:2%">
  </div>

  <!--Div : Col : Reports section-->
  <div style="background-color:#ffffff; width:38%; float:right;padding:0px;" authenticate-user="TPMReports.Retrieve">
    <div *ngIf="dashboardData" style="vertical-align:top">
      <app-report-layout></app-report-layout>
    </div>
  </div>
  <!--<div style="display:block; width:38%; float:right">
    <div style="width:113%;margin-left:2% ; display:inline-block;float:right ;">

    </div>
  </div>-->

</div>


